/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Trainee
 */
export interface Trainee {
    /**
     * 
     * @type {string}
     * @memberof Trainee
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Trainee
     */
    userId: string;
}

/**
 * Check if a given object implements the Trainee interface.
 */
export function instanceOfTrainee(value: object): value is Trainee {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function TraineeFromJSON(json: any): Trainee {
    return TraineeFromJSONTyped(json, false);
}

export function TraineeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Trainee {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'userId': json['userId'],
    };
}

export function TraineeToJSON(json: any): Trainee {
    return TraineeToJSONTyped(json, false);
}

export function TraineeToJSONTyped(value?: Trainee | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'userId': value['userId'],
    };
}

